module.exports = __webpack_public_path__ + "static/media/thai_run.609e2b30.png";